import NiceModal from "@ebay/nice-modal-react";
import CommonModal from "../CommonModal";
import CommonButton from "../../common/commonButton/CommonButton";
import MetaMaskImg from "../../../assets/images/metamask.png";
import TrustWalletImg from "../../../assets/images/trustwallet.png";
import MEWImg from "../../../assets/images/mew.png";
import TokenPocketImg from "../../../assets/images/tokenPocket.png";
import MathWalletImg from "../../../assets/images/mathwallet.png";
import CoinWalletImg from "../../../assets/images/coin98wallet.png";
import "./ConnectWalletModal.scss";
const ConnectWalletModal = NiceModal.create(
  ({ closeConnectWalletModal }: any) => {
    const list = [
      {
        title: "MetaMask",
        img: MetaMaskImg,
      },
      {
        title: "Trust Wallet",
        img: TrustWalletImg,
      },
      {
        title: "MEW",
        img: MEWImg,
      },
      {
        title: "Token Pocket",
        img: TokenPocketImg,
      },
      {
        title: "Math Wallet",
        img: MathWalletImg,
      },
      {
        title: "Coin 98 Wallet",
        img: CoinWalletImg,
      },
    ];
    return (
      <CommonModal
        className="connectwalletmodal"
        show
        onHide={closeConnectWalletModal}
        heading="Connect to a wallet"
      >
        <div className="connectwalletmodal_list">
          <ul>
            {list.map((item: any, index: number) => (
              <li key={index}>
                <CommonButton
                  title={item.title}
                  imgicon={item.img}
                  onClick={closeConnectWalletModal}
                  className="full connectwalletmodal_list_btn"
                />
              </li>
            ))}
          </ul>
        </div>
      </CommonModal>
    );
  }
);

export default ConnectWalletModal;
